import { locationIdFormat } from "@redotech/redo-inventory-id";
import { productIdFormat } from "@redotech/redo-product-id";
import { binAssignmentSessionIdFormat } from "@redotech/redo-warehouse-id";
import * as z from "zod";

export const createBinAssignmentSession = {
  name: "createBinAssignmentSession" as const,
  input: z.object({ locationId: locationIdFormat.schema }),
  output: z.object({ sessionId: binAssignmentSessionIdFormat.schema }),
};

export const getBinAssignmentSession = {
  name: "getBinAssignmentSession" as const,
  input: z.object({ sessionId: binAssignmentSessionIdFormat.schema }),
  output: z.object({
    sessionId: binAssignmentSessionIdFormat.schema,
    products: z.array(
      z.object({
        productId: productIdFormat.schema,
        binNames: z.array(z.string()),
        productTitle: z.string(),
        productSku: z.string().nullable(),
        productImageUrl: z.string().nullable(),
        productBarcode: z.string().nullable(),
        storeName: z.string().nullish(),
        currentBinNames: z.array(z.string()).nullish(),
      }),
    ),
    createdAt: z.string(),
    completedAt: z.string().nullable(),
  }),
};

export const getActiveBinAssignmentSessions = {
  name: "getActiveBinAssignmentSessions" as const,
  input: z.object({ locationId: locationIdFormat.schema }),
  output: z.object({
    sessions: z.array(
      z.object({
        sessionId: binAssignmentSessionIdFormat.schema,
        productCount: z.number(),
        createdAt: z.string(),
      }),
    ),
  }),
};

export const getBinAssignmentProductBins = {
  name: "getBinAssignmentProductBins" as const,
  input: z.object({
    locationId: locationIdFormat.schema,
    productId: productIdFormat.schema,
  }),
  output: z.object({
    binsTracked: z.boolean(),
    products: z.array(
      z.object({
        productId: productIdFormat.schema,
        storeName: z.string().nullable(),
        title: z.string(),
        sku: z.string().nullable(),
        imageUrl: z.string().nullable(),
        bins: z.array(z.object({ name: z.string(), quantity: z.number() })),
      }),
    ),
  }),
};

export const upsertBinAssignmentProduct = {
  name: "upsertBinAssignmentProduct" as const,
  input: z.object({
    sessionId: binAssignmentSessionIdFormat.schema,
    productId: productIdFormat.schema,
    binNames: z.array(z.string()),
  }),
  output: z.object({ success: z.boolean() }),
};

export const removeBinAssignmentProduct = {
  name: "removeBinAssignmentProduct" as const,
  input: z.object({
    sessionId: binAssignmentSessionIdFormat.schema,
    productId: productIdFormat.schema,
  }),
  output: z.object({ success: z.boolean() }),
};

export const completeBinAssignmentSession = {
  name: "completeBinAssignmentSession" as const,
  input: z.object({ sessionId: binAssignmentSessionIdFormat.schema }),
  output: z.object({
    success: z.boolean(),
    productsUpdated: z.number(),
    errors: z.array(z.string()),
  }),
};

export const cancelBinAssignmentSession = {
  name: "cancelBinAssignmentSession" as const,
  input: z.object({ sessionId: binAssignmentSessionIdFormat.schema }),
  output: z.object({ success: z.boolean() }),
};
